export interface UserToClientLifecycleFilterType {
  options: UserToClientLifecycleOption[]
}

export interface UserToClientLifecycleOption {
  label: string
  value: server.dto.UserToClientLifeCycles
}

export const UserToClientLifecycleOptions: UserToClientLifecycleOption[] = [
  {
    label: RESX.SoUser.Active,
    value: "active"
  },
  {
    label: RESX.SoUser.Deactivated,
    value: "archived"
  }
  // {
  //   label: RESX.Advancing.Hidden,
  //   value: "isDeleted"
  // }
];

export const getOption = (value: server.dto.UserToClientLifeCycles): UserToClientLifecycleOption => {
  return (
    UserToClientLifecycleOptions.find((opt) => opt.value === value)
  );
};

export const initialUserToClientLifecycleOption: UserToClientLifecycleFilterType = {
  options: []
};
